import apiRequest from '@/utils/apiRequest';
import { RequestUserData } from '@/utils/apiRequest/types';

import { pxTestHeaders } from '../../utils/apiRequest/perimeterx';
import { JSONValue } from '../../utils/types';

interface ApiFeatureFlag {
	name: string;
	value: JSONValue;
}

export interface ApiFeatureFlagResponse {
	feature_flags: ApiFeatureFlag[];
}

export async function getFeatureFlags(
	flags: string[] | undefined,
	userData: RequestUserData,
): Promise<ApiFeatureFlagResponse | null> {
	try {
		const endpoint =
			flags && Boolean(flags?.length) ? `feature-flags?filter[name]=${flags.join(',')}` : 'feature-flags';

		const result = await apiRequest<ApiFeatureFlagResponse>({
			endpoint,
			method: 'GET',
			userData,
			customHeaders: {
				...pxTestHeaders,
			},
		});
		return result?.data;
	} catch (err) {
		return null;
	}
}
